import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Tooltip from '@material-ui/core/Tooltip';

import { QRCodeSVG } from 'qrcode.react';
import { FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { mask } from 'remask';

import AttachFileIcon from '@material-ui/icons/AttachFile';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import BackupIcon from '@material-ui/icons/Backup';
import CheckIcon from '@material-ui/icons/Check';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteOutlineOutlined from '@material-ui/icons/DeleteOutlineOutlined';
import DescriptionIcon from '@material-ui/icons/Description';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import LabelIcon from '@material-ui/icons/Label';
import SearchIcon from '@material-ui/icons/Search';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

import DialogoPixCode from '../../components/DialogoPixCode';
import DialogDocumentData from '../DialogDocumentData';
import Dialogoconfirmacao from '../Dialogoconfirmacao';
import Dialogoencontrarlocalizacao from '../Dialogoencontrarlocalizacao';
import Modalpdf from '../Modalpdf';

import {
  DELETE_DOCUMENT_BY_ID,
  DELETE_INVERTERS,
  DELETE_PENDENCIES,
  GET_DEALER_BY_STATE,
  PATCH_DOCUMENT_APROVE,
  PATCH_PENDENCIES,
  POST_INVERTERS,
  POST_NEW_DOCUMENT,
  POST_PENDENCIES,
  PUT_INVERTERS_BY_ID,
  PUT_PROJECTS,
  SET_CANCEL_PAYMENT_ID,
  SET_PAYMENT_ID,
} from '../../services/endpoints';

import { listStates } from '../../config';
import { useAuth } from '../../contexts/AuthContext';
import SimpleBackdrop from '../Backdrop';
import { Container, FielButtons } from './styles';

const sortDesc = (a, b) => new Date(b.created_at) - new Date(a.created_at);
const getLatestReceipt = (receipts = []) =>
  receipts && receipts.length ? [...receipts].sort(sortDesc)[0] : null;

export default function Dialogoverprojeto(props) {
  const { user } = useAuth();

  const [showbackdrop, setShowbackdrop] = React.useState(false);
  const [open, setOpen] = React.useState(true);

  const [dados, setDados] = React.useState({ ...(props.dados || {}) });
  const [reset, setReset] = React.useState(props.dados || {});

  const [listConcess, setListConcess] = React.useState(null);
  const [editar, setEditar] = React.useState(!props.dados_edit);
  const [showcoord, setShowcoord] = React.useState(false);

  const [listinverters, setListinverters] = React.useState(
    props.dados?.inverters || []
  );
  const [newInverters, setNewInverters] = React.useState({
    new: false,
    project_id: props.dados?.id,
    amount: '',
    power_kwp: '',
    model: '',
  });

  const [listpendencias, setListpendencias] = React.useState(
    props.dados?.pendencies || []
  );
  const [openNewPendencia, setOpenNewPendencia] = React.useState(false);
  const [newPendencia, setNewPendencia] = React.useState({
    project_id: props.dados?.id,
    type: '',
    title: '',
    description: '',
  });

  const [listarchives, setListarchives] = React.useState(
    props.dados?.documents || []
  );
  const [listidx, setListidx] = React.useState(3);
  const [document, setDocument] = React.useState({
    open: false,
    type: '',
    other_type: '',
    document_additional: '',
  });

  const [showPDF, setShowPDF] = React.useState({ open: false, file_pdf: '' });
  const [showDocumentData, setShowDocumentData] = React.useState({
    open: false,
    data: {},
  });

  const [viewPixCode, setViewPixCode] = React.useState({
    status: false,
    id: '',
    pixCode: '',
  });

  const [showconf, setShowconf] = React.useState({
    status: false,
    width: 'sm',
    title: 'Confirmar',
    description: '',
    btn_conf: 'Sim',
    btn_cancel: 'Não',
    delete: true,
    dados: '',
    temp: '',
  });

  const [listdisjuntores] = React.useState([
    '2 A',
    '4 A',
    '6 A',
    '10 A',
    '16 A',
    '20 A',
    '25 A',
    '32 A',
    '40 A',
    '50 A',
    '63 A',
    '70 A',
    '80 A',
    '100 A',
    '125 A',
    'Outro',
  ]);

  React.useEffect(() => {
    setEditar(!props.dados_edit);
    setDados({ ...(props.dados || {}) });
    if (props.dados?.dealer?.state) {
      GET_DEALER_BY_STATE(
        props.dados.dealer.state,
        setListConcess,
        setShowbackdrop
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => props.fechar && props.fechar(), 100);
  };

  const handleCopy = () => {
    const code = dados?.pix_code || '';
    if (!code) return;
    navigator.clipboard
      .writeText(code)
      .then(() => toast.success('Código copiado com sucesso'))
      .catch(() => {});
  };

  const onInputChange = (e) => {
    if (e.target.name === 'other_value_disjuntor') {
      setDados((s) => ({ ...s, [e.target.name]: mask(e.target.value, '999') }));
    } else if (e.target.name === 'latitude' || e.target.name === 'longitude') {
      setDados((s) => ({ ...s, [e.target.name]: e.target.value }));
    } else {
      setDados((s) => ({ ...s, [e.target.name]: e.target.value }));
    }
  };

  const onInputChangeClient = (e) => {
    if (e.target.name === 'client_cpf') {
      setDados((s) => ({
        ...s,
        [e.target.name]: mask(e.target.value, '999.999.999-99'),
      }));
    } else if (e.target.name === 'client_cnpj') {
      setDados((s) => ({
        ...s,
        [e.target.name]: mask(e.target.value, '99.999.999/9999-99'),
      }));
    } else {
      setDados((s) => ({ ...s, [e.target.name]: e.target.value }));
    }
  };

  const onInputChangeDealer = (e) => {
    if (e.target.name === 'state') {
      setDados((s) => ({
        ...s,
        dealer: { ...s.dealer, state: e.target.value },
      }));
      GET_DEALER_BY_STATE(e.target.value, setListConcess, setShowbackdrop);
    } else if (e.target.name === 'dealer_id') {
      setDados((s) => ({ ...s, dealer_id: Number(e.target.value) }));
    }
  };

  const onInputChangeSpecifications = (e) => {
    setDados((s) => ({
      ...s,
      [e.target.name]:
        e.target.name === 'panel_model'
          ? e.target.value
          : Number(mask(e.target.value, '999')),
    }));
  };

  async function handleSubmitEditProject(e) {
    e.preventDefault();
    setReset(dados);
    for (const inverter of listinverters) {
      await PUT_INVERTERS_BY_ID(inverter.id, inverter, setShowbackdrop);
    }
    await PUT_PROJECTS(
      dados.id,
      dados,
      props.atualizar,
      setDados,
      setShowbackdrop
    );
    setEditar((v) => !v);
  }

  function deletePendencia() {
    setTimeout(() => {
      setListpendencias((arr) => arr.filter((p) => p.id !== showconf.dados.id));
      setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }));
      DELETE_PENDENCIES(showconf.dados.id, props.atualizar, setShowbackdrop);
    }, 100);
  }

  function confirmarPendencia() {
    setTimeout(() => {
      setListpendencias((arr) =>
        arr.map((p) =>
          p.id === showconf.dados.id ? { ...p, resolved: !p.resolved } : p
        )
      );
      setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }));
      PATCH_PENDENCIES(showconf.dados, props.atualizar, setShowbackdrop);
    }, 100);
  }

  function submitNewArchive() {
    const title = document?.other_type ? document.other_type : document.type;
    if (!title) {
      toast.warn('Título do documento é obrigatório');
      return;
    }
    const fd = new FormData();
    fd.append('file', document.document_additional);
    fd.append('title', title);
    fd.append('project_id', dados.id);
    POST_NEW_DOCUMENT(fd, setListarchives, props.atualizar, setShowbackdrop);
    setDocument({
      open: false,
      type: '',
      other_type: '',
      document_additional: '',
    });
  }

  function deleteArquivoVinculado() {
    setTimeout(async () => {
      setDocument((d) => ({ ...d, document_additional: '' }));
      setListarchives((arr) =>
        arr.filter((doc) => doc.id !== showconf.dados.id)
      );
      setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }));
      await DELETE_DOCUMENT_BY_ID(
        showconf.dados.id,
        props.atualizar,
        setShowbackdrop
      );
    }, 100);
  }

  function confirmarArquivo() {
    setTimeout(async () => {
      setDocument((d) => ({ ...d, document_additional: '' }));
      setListarchives((arr) =>
        arr.map((doc) =>
          doc.id === showconf.dados.id
            ? { ...doc, is_approved: !doc.is_approved }
            : doc
        )
      );
      setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }));
      await PATCH_DOCUMENT_APROVE(
        showconf.dados,
        props.atualizar,
        setShowbackdrop
      );
    }, 100);
  }

  function removerArquivo() {
    setTimeout(() => {
      setDocument((d) => ({ ...d, document_additional: '' }));
      setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }));
    }, 100);
  }

  function deleteInverters() {
    setTimeout(() => {
      setListinverters((arr) =>
        arr.filter((inv) => inv.id !== showconf.dados.id)
      );
      setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }));
      DELETE_INVERTERS(showconf.dados.id, props.atualizar, setShowbackdrop);
    }, 100);
  }

  async function handleSubmitNewInverters(e) {
    e.preventDefault();
    await POST_INVERTERS(
      newInverters,
      props.atualizar,
      setListinverters,
      setShowbackdrop
    );
    setNewInverters({
      new: false,
      project_id: dados?.id,
      amount: '',
      power_kwp: '',
      model: '',
    });
  }

  async function handleSubmitPendencia(e) {
    e.preventDefault();
    const fd = new FormData();
    fd.append('project_id', newPendencia.project_id);
    if (newPendencia.type === 'arquivo')
      fd.append('file', document.document_additional);
    fd.append('title', newPendencia.title);
    fd.append('description', newPendencia.description);
    await POST_PENDENCIES(
      fd,
      props.atualizar,
      setListpendencias,
      setShowbackdrop
    );
    setNewPendencia({
      project_id: dados?.id,
      type: '',
      title: '',
      description: '',
    });
    removerArquivo();
    setOpenNewPendencia(false);
  }

  async function resetDados() {
    if (props?.dados?.dealer?.state) {
      GET_DEALER_BY_STATE(
        props.dados.dealer.state,
        setListConcess,
        setShowbackdrop
      );
    }
    setDados(reset);
    setListinverters(props.dados?.inverters || []);
    setNewInverters({
      new: false,
      project_id: dados?.id,
      amount: '',
      power_kwp: '',
      model: '',
    });
  }

  const latestReceipt = getLatestReceipt(dados?.receipts);
  const paymentIsPaid = !!latestReceipt?.is_paid;

  const handlePixUpdated = (code) => {
    setDados((s) => ({ ...s, pix_code: code }));
    props.onProjectPixUpdated?.(dados.id, code);
  };

  const handlePaymentUpdatedLocal = (receiptId, isPaid) => {
    setDados((s) => ({
      ...s,
      receipts: (s.receipts || []).map((r) =>
        r.id === receiptId ? { ...r, is_paid: isPaid } : r
      ),
    }));
    props.onProjectPaymentUpdated?.(dados.id, receiptId, isPaid);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          props.fechar();
        }}
        maxWidth="md"
        scroll="body"
        fullScreen={window.innerWidth <= 675}
        fullWidth
        style={{ zIndex: 9999 }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Container suspended={dados.suspended}>
              <header>
                <h1>Dados do Projeto</h1>
                <span>
                  Confira abaixo os dados do projeto com mais detalhes.
                </span>

                {props?.dados_edit && (
                  <div
                    className="div__listpendencias"
                    style={{ marginTop: '1rem', marginBottom: '1rem' }}
                  >
                    <div className="div__pendencias">
                      <ErrorOutlineIcon className="icone_warn" />
                      <div className="div__info" style={{ flex: 10 }}>
                        <h5>{props?.dados_edit.title}</h5>
                        <p>{props?.dados_edit.description}</p>
                      </div>
                    </div>
                  </div>
                )}

                {editar && !dados.suspended && !dados.finished_at && (
                  <div className="div__moreFiles">
                    <button
                      type="button"
                      className="btn__newFile"
                      onClick={() => setEditar(false)}
                    >
                      Editar Projeto
                    </button>
                  </div>
                )}

                <content>
                  <h4>Informações da Concessionária</h4>
                  {editar ? (
                    <div className="div__oneRow">
                      <p>
                        <label>Estado: </label> {dados.dealer?.state}
                      </p>
                      <p>
                        <label>Concessionária: </label>
                        {
                          listConcess?.find((c) => c.id === dados.dealer_id)
                            ?.name
                        }
                      </p>
                    </div>
                  ) : (
                    <div className="div__oneRow">
                      <select
                        required
                        name="state"
                        style={{ flex: 1 }}
                        value={dados.dealer?.state || ''}
                        onChange={onInputChangeDealer}
                      >
                        <option value="" disabled>
                          Estado
                        </option>
                        {listStates.map((uf) => (
                          <option key={uf} value={uf}>
                            {uf}
                          </option>
                        ))}
                      </select>
                      <select
                        required
                        disabled={!dados?.dealer?.state}
                        name="dealer_id"
                        style={{ flex: 3 }}
                        value={dados.dealer_id || ''}
                        onChange={onInputChangeDealer}
                      >
                        <option value="" disabled>
                          Nome da concessionária
                        </option>
                        {listConcess?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  <h4>Informações do Cliente</h4>
                  {editar ? (
                    <div className="div__oneRow">
                      {dados?.client_cpf ? (
                        <p>
                          <label>CPF: </label> {dados?.client_cpf}
                        </p>
                      ) : (
                        <p>
                          <label>CNPJ: </label> {dados?.client_cnpj}
                        </p>
                      )}
                      <p>
                        <label>Nome: </label> {dados?.client_name}
                      </p>
                    </div>
                  ) : (
                    <div className="div__oneRow">
                      <input
                        type="text"
                        placeholder={dados?.client_cpf ? 'CPF' : 'CNPJ'}
                        value={
                          dados?.client_cpf
                            ? dados?.client_cpf
                            : dados?.client_cnpj || ''
                        }
                        onChange={onInputChangeClient}
                        name={dados?.client_cpf ? 'client_cpf' : 'client_cnpj'}
                        style={{ flex: 1 }}
                        required
                      />
                      <input
                        type="text"
                        placeholder={
                          dados?.client_cpf ? 'Nome completo' : 'Razão social'
                        }
                        value={dados?.client_name || ''}
                        onChange={onInputChangeClient}
                        name="client_name"
                        style={{ flex: 3 }}
                        required
                      />
                    </div>
                  )}

                  <h4>Informações da Instalação - Unidade Geradora</h4>
                  {editar ? (
                    <div className="div__oneRow">
                      <p>
                        <label>Disjuntor: </label> {dados.breaker_type}
                      </p>
                      <p>
                        <label>Valor: </label> {dados.breaker_value}
                      </p>
                      <p>
                        <label>Coordenadas: </label> {dados.latitude} ,{' '}
                        {dados.longitude}
                      </p>
                    </div>
                  ) : (
                    <>
                      <div
                        className="div__oneRow"
                        style={{ maxWidth: '690px' }}
                      >
                        <select
                          required
                          name="breaker_type"
                          style={{ flex: 1 }}
                          value={dados.breaker_type || ''}
                          onChange={onInputChange}
                        >
                          <option value="" disabled>
                            Tipo de disjuntor
                          </option>
                          <option value="monofásico">Monofásico</option>
                          <option value="bifásico">Bifásico</option>
                          <option value="trifásico">Trifásico</option>
                        </select>
                        <select
                          required
                          name="breaker_value"
                          style={{ flex: 2 }}
                          value={dados.breaker_value || ''}
                          onChange={onInputChange}
                        >
                          <option value="" disabled>
                            Valor do disjuntor
                          </option>
                          {listdisjuntores.map((d) => (
                            <option key={d} value={d}>
                              {d}
                            </option>
                          ))}
                        </select>
                        <input
                          type="text"
                          name="other_value_disjuntor"
                          value={dados.other_value_disjuntor || ''}
                          placeholder="Valor do disjuntor (ex. 16 A)"
                          style={{
                            flex: 2,
                            visibility:
                              dados.value_disjuntor === 'Outro'
                                ? 'visible'
                                : 'hidden',
                          }}
                          onChange={onInputChange}
                          required={dados.value_disjuntor === 'Outro'}
                        />
                        <div
                          className="pos_field"
                          style={{
                            visibility:
                              dados.value_disjuntor === 'Outro'
                                ? 'visible'
                                : 'hidden',
                          }}
                        >
                          A
                        </div>
                      </div>

                      <div
                        className="div__oneRow"
                        style={{ maxWidth: '530px' }}
                      >
                        <input
                          type="number"
                          placeholder="Latitude do projeto"
                          value={dados.latitude || ''}
                          onChange={onInputChange}
                          name="latitude"
                          style={{ flex: 1 }}
                          required
                        />
                        <input
                          type="number"
                          placeholder="Longitude do projeto"
                          value={dados.longitude || ''}
                          onChange={onInputChange}
                          name="longitude"
                          style={{ flex: 1 }}
                          required
                        />
                        <div className="div__moreOptions">
                          <button
                            type="button"
                            className="btn__newDocument"
                            style={{ alignItems: 'center', display: 'flex' }}
                            onClick={() => setShowcoord(true)}
                          >
                            <SearchIcon /> Buscar
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  <h4>
                    Especificações do Projeto
                    {!dados?.finished_at && editar && !dados.suspended && (
                      <div className="div__moreOptions">
                        <button
                          type="button"
                          className="btn__newDocument"
                          onClick={() =>
                            setNewInverters((inv) => ({ ...inv, new: true }))
                          }
                        >
                          + Adicionar Inversor
                        </button>
                      </div>
                    )}
                  </h4>

                  {editar ? (
                    <>
                      <div className="div__oneRow">
                        <p>
                          <label>Potência Total do Projeto: </label>{' '}
                          {dados?.total_project_power} kWP
                        </p>
                      </div>
                      {dados?.amount_panels &&
                        dados?.panel_power &&
                        dados?.panel_model && (
                          <div className="div__oneRow">
                            <p>
                              <label>Qtd. de Placas: </label>{' '}
                              {dados?.amount_panels ?? 'Nenhuma'}
                            </p>
                            <p>
                              <label>Potência: </label>{' '}
                              {dados?.panel_power
                                ? `${dados?.panel_power} KWP`
                                : 'Nenhuma'}
                            </p>
                            <p>
                              <label>Modelo: </label>{' '}
                              {dados?.panel_model ?? 'Nenhum'}
                            </p>
                          </div>
                        )}
                      <br />

                      {newInverters.new && (
                        <form onSubmit={handleSubmitNewInverters}>
                          <div
                            className="div__oneRow"
                            style={{ maxWidth: '100%' }}
                          >
                            <input
                              type="text"
                              name="amount"
                              value={newInverters.amount}
                              placeholder="Qtd. de inversores"
                              style={{ flex: 1 }}
                              onChange={(e) =>
                                setNewInverters((inv) => ({
                                  ...inv,
                                  amount: Number(mask(e.target.value, '999')),
                                }))
                              }
                              required
                            />
                            <div className="pos_field">Inversor(es)</div>
                            <input
                              type="text"
                              name="power_kwp"
                              value={newInverters.power_kwp}
                              placeholder="Potência"
                              style={{ flex: 1 }}
                              onChange={(e) =>
                                setNewInverters((inv) => ({
                                  ...inv,
                                  power_kwp: Number(
                                    mask(e.target.value, '999')
                                  ),
                                }))
                              }
                              required
                            />
                            <div className="pos_field">kWp</div>
                            <input
                              type="text"
                              name="model"
                              value={newInverters.model}
                              placeholder="Modelo dos inversores"
                              style={{ flex: 2 }}
                              onChange={(e) =>
                                setNewInverters((inv) => ({
                                  ...inv,
                                  model: e.target.value,
                                }))
                              }
                              required
                            />
                          </div>
                          <div
                            className="div__moreFiles"
                            style={{ marginTop: '1rem' }}
                          >
                            <button
                              type="button"
                              className="btn__cancel"
                              onClick={() =>
                                setNewInverters({
                                  new: false,
                                  project_id: dados?.id,
                                  amount: '',
                                  power_kwp: '',
                                  model: '',
                                })
                              }
                            >
                              Cancelar
                            </button>
                            <button type="submit" className="btn__newFile">
                              Adicionar
                            </button>
                          </div>
                        </form>
                      )}

                      {listinverters.length > 0
                        ? listinverters.map((inverter) => (
                            <fieldset
                              key={inverter.id}
                              style={{ marginBottom: '1rem' }}
                              className="div__oneRow"
                            >
                              <p>
                                <label>Qtd. de Inversores: </label>{' '}
                                {inverter.amount}
                              </p>
                              <p>
                                <label>Potência: </label> {inverter.power_kwp}{' '}
                                kWP
                              </p>
                              <p>
                                <label>Modelo: </label> {inverter.model}
                              </p>
                              <legend>
                                <HighlightOffIcon
                                  style={{
                                    color: 'var(--delete)',
                                    cursor: 'pointer',
                                    zIndex: '99991',
                                  }}
                                  onClick={() =>
                                    setShowconf({
                                      ...showconf,
                                      status: true,
                                      dados: inverter,
                                      delete: true,
                                      pendencia: false,
                                      arquivoVinculado: false,
                                      removeDocument: false,
                                      removeInverter: true,
                                      width: 'sm',
                                      title: 'Confirmar',
                                      description:
                                        'Deseja realmente remover o inversor do projeto?',
                                    })
                                  }
                                />
                              </legend>
                            </fieldset>
                          ))
                        : !newInverters.new && (
                            <div className="div__nada">
                              Nenhum inversor cadastrado
                            </div>
                          )}
                    </>
                  ) : (
                    <>
                      <div
                        className="div__oneRow"
                        style={{ maxWidth: '700px', width: '100%' }}
                      >
                        <input
                          type="text"
                          name="total_project_power"
                          value={dados?.total_project_power || ''}
                          placeholder="Potência total do projeto em kWp"
                          style={{ flex: 1 }}
                          onChange={onInputChangeSpecifications}
                          disabled
                          required
                        />
                        <div className="pos_field">kWp</div>
                      </div>
                      <div className="div__oneRow" style={{ maxWidth: '100%' }}>
                        <input
                          type="text"
                          name="amount_panels"
                          value={dados?.amount_panels || ''}
                          placeholder="Qtd. de placas"
                          style={{ flex: 1.19 }}
                          onChange={onInputChangeSpecifications}
                          required
                        />
                        <div className="pos_field">Placa(s)</div>
                        <input
                          type="text"
                          name="panel_power"
                          value={dados?.panel_power || ''}
                          placeholder="Potência"
                          style={{ flex: 1 }}
                          onChange={onInputChangeSpecifications}
                          required
                        />
                        <div className="pos_field">Wp</div>
                        <input
                          type="text"
                          name="panel_model"
                          value={dados?.panel_model || ''}
                          placeholder="Modelo das placas"
                          style={{ flex: 2 }}
                          onChange={onInputChangeSpecifications}
                        />
                      </div>

                      {listinverters?.map((inverter, idx) => (
                        <div
                          key={inverter.id}
                          className="div__oneRow"
                          style={{ maxWidth: '100%' }}
                        >
                          <input
                            type="text"
                            name="amount"
                            value={inverter.amount}
                            placeholder="Qtd. de inversores"
                            style={{ flex: 1 }}
                            onChange={(e) =>
                              setListinverters(
                                listinverters.map((inv, id) =>
                                  id === idx
                                    ? { ...inv, amount: e.target.value }
                                    : inv
                                )
                              )
                            }
                            required
                          />
                          <div className="pos_field">Inversor(es)</div>
                          <input
                            type="text"
                            name="power_kwp"
                            value={inverter.power_kwp}
                            placeholder="Potência"
                            style={{ flex: 1 }}
                            onChange={(e) =>
                              setListinverters(
                                listinverters.map((inv, id) =>
                                  id === idx
                                    ? { ...inv, power_kwp: e.target.value }
                                    : inv
                                )
                              )
                            }
                            required
                          />
                          <div className="pos_field">kWp</div>
                          <input
                            type="text"
                            name="model"
                            value={inverter.model}
                            placeholder="Modelo dos inversores"
                            style={{ flex: 2 }}
                            onChange={(e) =>
                              setListinverters(
                                listinverters.map((inv, id) =>
                                  id === idx
                                    ? { ...inv, model: e.target.value }
                                    : inv
                                )
                              )
                            }
                          />
                        </div>
                      ))}
                    </>
                  )}

                  {!editar && !dados.suspended && !dados?.finished_at && (
                    <div
                      className="div__moreFiles"
                      style={{ marginTop: '1rem' }}
                    >
                      <button
                        type="button"
                        className="btn__cancel"
                        onClick={() => {
                          resetDados();
                          setEditar(true);
                        }}
                      >
                        Cancelar
                      </button>
                      <button
                        type="button"
                        className="btn__newFile"
                        onClick={handleSubmitEditProject}
                      >
                        Salvar edição
                      </button>
                    </div>
                  )}

                  {dados.comments && (
                    <>
                      <h4>Observações</h4>
                      <div className="div__oneRow" style={{ maxWidth: '100%' }}>
                        <p>{dados.comments}</p>
                      </div>
                    </>
                  )}

                  {!dados?.finished_at &&
                    !dados?.suspended &&
                    user?.role === 'GERENTE' && (
                      <div className="div__payments">
                        <h4>Pagamento</h4>
                        <div className="buttons__payments">
                          <Tooltip
                            placement="bottom-start"
                            title={
                              paymentIsPaid
                                ? 'Cancelar pagamento'
                                : 'Confirmar pagamento'
                            }
                          >
                            <span>
                              <button
                                className={
                                  paymentIsPaid
                                    ? 'button_payment button_cancel_payment'
                                    : 'button_payment'
                                }
                                onClick={() => {
                                  if (!latestReceipt) {
                                    toast.warn(
                                      'O recibo de pagamento não foi encontrado'
                                    );
                                    return;
                                  }

                                  const receiptId = latestReceipt.id;
                                  if (paymentIsPaid) {
                                    setShowconf({
                                      ...showconf,
                                      status: true,
                                      width: 'sm',
                                      title: 'Confirmar',
                                      description: `Deseja realmente cancelar o pagamento do projeto de ${dados.client_name}?`,
                                      btn_conf: 'Sim',
                                      btn_cancel: 'Não',
                                      delete: true,
                                      dados,
                                      type: 'SET_CANCEL_PAYMENT_ID',
                                      receiptId,
                                    });
                                  } else {
                                    setShowconf({
                                      ...showconf,
                                      status: true,
                                      width: 'sm',
                                      title: 'Confirmar',
                                      description: `Deseja realmente confirmar o pagamento do projeto de ${dados.client_name}?`,
                                      btn_conf: 'Sim',
                                      btn_cancel: 'Não',
                                      delete: false,
                                      dados,
                                      type: 'SET_PAYMENT_ID',
                                      receiptId,
                                    });
                                  }
                                }}
                              >
                                {paymentIsPaid
                                  ? 'Cancelar pagamento'
                                  : 'Confirmar pagamento'}
                              </button>
                            </span>
                          </Tooltip>

                          <Tooltip
                            placement="bottom-start"
                            title={
                              dados.pix_code ? 'Editar Pix' : 'Adicionar Pix'
                            }
                          >
                            <button
                              className="button_payment"
                              onClick={() =>
                                setViewPixCode({
                                  status: true,
                                  id: dados.id,
                                  pixCode: dados.pix_code || '',
                                })
                              }
                            >
                              <AttachMoneyIcon />
                              {dados.pix_code ? 'Editar Pix' : 'Adicionar Pix'}
                            </button>
                          </Tooltip>
                        </div>
                      </div>
                    )}

                  {dados?.pix_code && user?.role === 'GERENTE' && (
                    <div>
                      <h4>Pix do Projeto</h4>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 10,
                        }}
                      >
                        <QRCodeSVG value={dados?.pix_code} />
                        <div>
                          <button className="button_copy" onClick={handleCopy}>
                            {dados?.pix_code?.length > 15
                              ? `${dados?.pix_code.slice(0, 15)}...`
                              : dados?.pix_code}{' '}
                            <FaCopy />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <h4>
                    Pendências
                    {!dados?.finished_at && editar && !dados.suspended && (
                      <div className="div__moreOptions">
                        <button
                          type="button"
                          className="btn__newDocument"
                          onClick={() => setOpenNewPendencia(true)}
                        >
                          + Adicionar nova pendência
                        </button>
                      </div>
                    )}
                  </h4>

                  {openNewPendencia &&
                    (!dados?.finished_at || !dados?.suspended) && (
                      <form onSubmit={handleSubmitPendencia}>
                        <div
                          className="div__oneRow"
                          style={{ maxWidth: '100%' }}
                        >
                          <input
                            type="text"
                            name="title"
                            placeholder="Título da pendência"
                            value={newPendencia.title}
                            onChange={(e) =>
                              setNewPendencia((p) => ({
                                ...p,
                                [e.target.name]: e.target.value,
                              }))
                            }
                            style={{ flex: 1 }}
                            required
                          />
                          <select
                            required
                            name="type"
                            style={{ flex: 1 }}
                            value={newPendencia.type}
                            onChange={(e) => {
                              setNewPendencia((p) => ({
                                ...p,
                                [e.target.name]: e.target.value,
                              }));
                              removerArquivo();
                            }}
                          >
                            <option value="" disabled>
                              Tipo de pendência
                            </option>
                            <option value="mensagem">Informação</option>
                            <option value="arquivo">Arquivo</option>
                          </select>
                        </div>
                        <div className="div__oneRow">
                          <textarea
                            id="description"
                            name="description"
                            placeholder="Nota de pendência"
                            value={newPendencia.description}
                            onChange={(e) =>
                              setNewPendencia((p) => ({
                                ...p,
                                [e.target.name]: e.target.value,
                              }))
                            }
                            required
                          />
                        </div>

                        {newPendencia.type === 'arquivo' ? (
                          <>
                            <input
                              type="file"
                              id="document_additional"
                              name="document_additional"
                              required
                              onChange={(e) => {
                                const f = e.target.files?.[0];

                                if (!f) return;

                                const fileType = f.type;
                                const extractedType = f.name?.split('.')[1];

                                if (
                                  [
                                    'application/pdf',
                                    'image/png',
                                    'image/jpeg',
                                    'application/acad',
                                    'application/octet-stream',
                                  ].includes(fileType) ||
                                  ['dwg'].includes(extractedType)
                                ) {
                                  setDocument((d) => ({
                                    ...d,
                                    document_additional: f,
                                  }));
                                } else {
                                  toast.error(
                                    'Tipo de arquivo inválido, insira .pdf, .png .jpeg ou .dwg'
                                  );
                                }
                              }}
                            />

                            <label
                              className={
                                document.document_additional
                                  ? 'div__newfieldarchive div__selectedFieldArchive'
                                  : 'div__newfieldarchive'
                              }
                              htmlFor={
                                document.document_additional
                                  ? ''
                                  : 'document_additional'
                              }
                              onClick={() => {
                                if (document.document_additional) {
                                  setShowconf({
                                    ...showconf,
                                    status: true,
                                    dados: document,
                                    temp: 'document_additional',
                                    removeDocument: true,
                                    pendencia: false,
                                  });
                                }
                              }}
                            >
                              <div className="div__newfieldarchive_in">
                                <div className="div__dataArchive">
                                  <AttachFileIcon />
                                  <div className="div__info">
                                    <p style={{ textTransform: 'uppercase' }}>
                                      <LabelIcon
                                        style={{
                                          fontSize: '1rem',
                                          marginBottom: '-0.2rem',
                                        }}
                                      />{' '}
                                      {document.type || ' . . . '}{' '}
                                      {document.other_type
                                        ? `(${document.other_type})`
                                        : ''}
                                    </p>
                                    <p>
                                      <b>Nome: </b>
                                      {document.document_additional
                                        ? document.document_additional.name
                                        : '...'}
                                    </p>
                                    <p>
                                      <b>Tamanho: </b>
                                      {document.document_additional
                                        ? (
                                            document.document_additional.size /
                                            (1024 * 1024)
                                          ).toFixed(2) + 'Mb'
                                        : '...'}
                                    </p>
                                    <p>
                                      <b>Tipo de arquivo: </b>
                                      {document.document_additional
                                        ? document.document_additional.type.split(
                                            '/'
                                          )[1]
                                        : '...'}
                                    </p>
                                  </div>
                                </div>
                                <div className="div__env_archive">
                                  {document.document_additional ? (
                                    <div>
                                      <DeleteIcon
                                        style={{ fontSize: '1.5rem' }}
                                      />{' '}
                                      Remover arquivo
                                      <br /> selecionado
                                    </div>
                                  ) : (
                                    <div>
                                      <BackupIcon /> Clique para anexar o
                                      arquivo
                                      <br />
                                      (.png .jpeg .pdf .dwg)
                                    </div>
                                  )}
                                </div>
                              </div>
                            </label>

                            <div className="div__moreFiles">
                              <button
                                type="button"
                                className="btn__cancel"
                                onClick={() => {
                                  setNewPendencia({
                                    project_id: dados?.id,
                                    type: '',
                                    title: '',
                                    description: '',
                                  });
                                  removerArquivo();
                                  setOpenNewPendencia(false);
                                }}
                              >
                                Cancelar
                              </button>
                              <button
                                type="submit"
                                className="btn__newFile"
                                style={{
                                  pointerEvents:
                                    !document.document_additional && 'none',
                                  filter:
                                    !document.document_additional &&
                                    'grayscale(1)',
                                }}
                              >
                                Cadastrar nova pendência
                              </button>
                            </div>
                          </>
                        ) : (
                          <div className="div__moreFiles">
                            <button
                              type="button"
                              className="btn__cancel"
                              onClick={() => {
                                setNewPendencia({
                                  project_id: dados?.id,
                                  type: '',
                                  title: '',
                                  description: '',
                                });
                                setOpenNewPendencia(false);
                              }}
                            >
                              Cancelar
                            </button>
                            <button
                              type="submit"
                              className="btn__newFile"
                              style={{ marginTop: '1rem' }}
                            >
                              Cadastrar nova pendência
                            </button>
                          </div>
                        )}
                      </form>
                    )}

                  <div className="div__listpendencias">
                    {listpendencias?.length > 0
                      ? listpendencias.map((pendencia) => (
                          <div key={pendencia.id} className="div__pendencias">
                            <div className="div__info" style={{ flex: 10 }}>
                              <h5>
                                {pendencia.resolved ? (
                                  <CheckCircleOutlineIcon className="icone_success" />
                                ) : (
                                  <ErrorOutlineIcon className="icone_warn" />
                                )}
                                {pendencia.title}{' '}
                                <span>
                                  {pendencia.file ? 'Arquivo' : 'Informação'}
                                </span>
                              </h5>
                              <p>{pendencia.description}</p>
                              {pendencia.customer_comment && (
                                <div className="div__respost_pendence">
                                  <div className="div__comment">
                                    <strong>R:</strong>{' '}
                                    {pendencia.customer_comment}
                                  </div>
                                </div>
                              )}
                            </div>
                            <div
                              className="div__options_pendencias"
                              style={{
                                flex: 2,
                                display: 'flex',
                                justifyContent: 'flex-end',
                              }}
                            >
                              {!pendencia.resolved ? (
                                !dados?.finished_at &&
                                !dados.suspended && (
                                  <button
                                    onClick={() =>
                                      setShowconf({
                                        ...showconf,
                                        status: true,
                                        dados: pendencia,
                                        btn_cancel: 'Voltar',
                                        description:
                                          'Deseja confirmar à resolução da pendência?',
                                        delete: false,
                                        arquivoVinculado: false,
                                        pendencia: true,
                                      })
                                    }
                                  >
                                    <CheckIcon />
                                  </button>
                                )
                              ) : (
                                <p>Resolvido</p>
                              )}
                              {pendencia.file && (
                                <button
                                  onClick={() => {
                                    const ext = pendencia.file
                                      ?.split('.')
                                      ?.pop();
                                    if (ext === 'pdf') {
                                      setShowPDF({
                                        open: true,
                                        file_pdf: pendencia.file_url,
                                      });
                                    } else if (pendencia.file_url) {
                                      window.open(pendencia.file_url);
                                    } else if (pendencia.data) {
                                      setShowDocumentData({
                                        open: true,
                                        data: pendencia.data,
                                      });
                                    }
                                  }}
                                >
                                  <VisibilityOutlinedIcon />
                                </button>
                              )}
                              <button
                                className="button_delete"
                                onClick={() =>
                                  setShowconf({
                                    ...showconf,
                                    status: true,
                                    dados: pendencia,
                                    description:
                                      'Deseja realmente remover esta pendência?',
                                    delete: true,
                                    arquivoVinculado: false,
                                    pendencia: true,
                                  })
                                }
                              >
                                <DeleteOutlineOutlined />
                              </button>
                            </div>
                          </div>
                        ))
                      : !openNewPendencia && (
                          <div className="div__nada">
                            Nenhuma pendência cadastrada
                          </div>
                        )}
                  </div>

                  <br />
                  <h4>
                    Arquivos vinculados
                    {!dados?.finished_at && editar && !dados.suspended && (
                      <div className="div__moreOptions">
                        <button
                          type="button"
                          className="btn__newDocument"
                          style={{
                            display: document.open ? 'none' : 'initial',
                          }}
                          onClick={() =>
                            setDocument({
                              ...document,
                              open: true,
                              type: 'Novo arquivo',
                            })
                          }
                        >
                          + Novo arquivo
                        </button>
                      </div>
                    )}
                  </h4>

                  {document.open && (
                    <div className="div__field_moreFiles">
                      <div style={{ textAlign: 'left', margin: '0rem 2rem' }}>
                        Novo documento
                      </div>
                    </div>
                  )}

                  {document.open && (
                    <input
                      type="file"
                      id="document_additional_main"
                      name="document_additional_main"
                      required
                      onChange={(e) => {
                        const f = e.target.files?.[0];
                        if (!f) return;

                        const extractedType = f.name?.split('.')[1];

                        if (
                          [
                            'application/pdf',
                            'image/png',
                            'image/jpeg',
                            'application/acad',
                            'application/octet-stream',
                          ].includes(f.type) ||
                          ['dwg'].includes(extractedType)
                        ) {
                          setDocument((d) => ({
                            ...d,
                            document_additional: f,
                          }));
                        } else {
                          toast.error(
                            'Tipo de arquivo inválido, insira .pdf, .png .jpeg ou .dwg'
                          );
                        }
                      }}
                    />
                  )}

                  {document.type && (
                    <div className="div__remove_field_arch">
                      <button
                        type="button"
                        className={
                          document.document_additional
                            ? 'btn__remove_field btn__remove_field_disabled'
                            : 'btn__remove_field'
                        }
                        onClick={() =>
                          setDocument({
                            open: false,
                            type: '',
                            other_type: '',
                            document_additional: '',
                          })
                        }
                      >
                        Remover campo
                      </button>
                    </div>
                  )}

                  {document.type && (
                    <label
                      className={
                        document.document_additional
                          ? 'div__newfieldarchive div__selectedFieldArchive'
                          : 'div__newfieldarchive'
                      }
                      htmlFor={
                        document.document_additional
                          ? ''
                          : 'document_additional_main'
                      }
                      onClick={() => {
                        if (document.document_additional) {
                          setDocument((d) => ({ ...d, open: false }));
                          setTimeout(
                            () =>
                              setDocument((d) => ({
                                ...d,
                                open: true,
                                document_additional: '',
                              })),
                            100
                          );
                        }
                      }}
                    >
                      <div className="div__newfieldarchive_in">
                        <div className="div__dataArchive">
                          <AttachFileIcon />
                          <div className="div__info">
                            <p
                              style={{
                                textTransform: 'uppercase',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <LabelIcon style={{ fontSize: '1rem' }} />{' '}
                              <input
                                style={{
                                  border: 'none',
                                  boxShadow: 'none',
                                  margin: 0,
                                  maxHeight: '0.5rem',
                                  fontSize: '1rem',
                                }}
                                disabled={!!document.document_additional}
                                defaultValue={
                                  document.type
                                    ? document.type
                                    : document.other_type
                                    ? `(${document.other_type})`
                                    : ''
                                }
                                onChange={(e) =>
                                  setDocument((d) => ({
                                    ...d,
                                    other_type: e.target.value,
                                  }))
                                }
                              />
                            </p>
                            <p>
                              <b>Nome: </b>
                              {document.document_additional
                                ? document.document_additional.name
                                : '...'}
                            </p>
                            <p>
                              <b>Tamanho: </b>
                              {document.document_additional
                                ? (
                                    document.document_additional.size /
                                    (1024 * 1024)
                                  ).toFixed(2) + 'Mb'
                                : '...'}
                            </p>
                            <p>
                              <b>Tipo de arquivo: </b>
                              {document.document_additional
                                ? document.document_additional.type.split(
                                    '/'
                                  )[1]
                                : '...'}
                            </p>
                          </div>
                        </div>
                        <div className="div__env_archive">
                          {document.document_additional ? (
                            <div>
                              <DeleteIcon style={{ fontSize: '1.5rem' }} />{' '}
                              Remover arquivo
                              <br /> selecionado
                            </div>
                          ) : (
                            <div>
                              <BackupIcon /> Clique para anexar a conta de
                              energia
                              <br />
                              (.png .jpeg .pdf .dwg)
                            </div>
                          )}
                        </div>
                      </div>
                    </label>
                  )}

                  {document.type && (
                    <div className="div__moreFiles">
                      <button
                        type="button"
                        className="btn__newFile"
                        style={{
                          pointerEvents:
                            !document.document_additional && 'none',
                          filter:
                            !document.document_additional && 'grayscale(1)',
                        }}
                        onClick={submitNewArchive}
                      >
                        Enviar novo arquivo
                      </button>
                    </div>
                  )}

                  <div className="div__listArchives">
                    {listarchives?.length > 0 ? (
                      listarchives.slice(0, listidx).map((archive) => (
                        <div key={archive.id} className="div__rowArchive">
                          <div className="div__icon">
                            <DescriptionIcon />
                          </div>
                          <div className="div__data" style={{ flex: 4 }}>
                            <p>
                              <strong>Título: </strong> {archive.title}
                            </p>
                            {archive.file && (
                              <p>
                                <strong>Arquivo: </strong> {archive.file}
                              </p>
                            )}
                            <p>
                              Envio em{' '}
                              {new Date(archive.created_at).toLocaleDateString(
                                'pt-br',
                                {
                                  day: '2-digit',
                                  month: 'long',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                }
                              )}
                            </p>
                          </div>

                          <div className="div__options" style={{ flex: 2 }}>
                            {!archive.is_approved ? (
                              !dados?.finished_at &&
                              !dados?.suspended && (
                                <button
                                  onClick={() =>
                                    setShowconf({
                                      ...showconf,
                                      status: true,
                                      dados: archive,
                                      description:
                                        'Deseja confirmar à aprovação deste arquivo?',
                                      delete: false,
                                      pendencia: false,
                                      arquivoVinculado: true,
                                    })
                                  }
                                >
                                  <CheckIcon />
                                </button>
                              )
                            ) : (
                              <p>Aprovado</p>
                            )}

                            <button
                              onClick={() => {
                                const ext = archive.file?.split('.')?.pop();
                                if (ext === 'pdf') {
                                  setShowPDF({
                                    open: true,
                                    file_pdf: archive.file_url,
                                  });
                                } else if (archive.file_url) {
                                  window.open(archive.file_url);
                                } else if (archive.data) {
                                  setShowDocumentData({
                                    open: true,
                                    data: archive.data,
                                  });
                                }
                              }}
                            >
                              <VisibilityOutlinedIcon />
                            </button>

                            {!dados?.finished_at && !dados.suspended && (
                              <button
                                className="button_delete"
                                onClick={() =>
                                  setShowconf({
                                    ...showconf,
                                    status: true,
                                    dados: archive,
                                    delete: true,
                                    pendencia: false,
                                    arquivoVinculado: true,
                                  })
                                }
                              >
                                <DeleteOutlineOutlined />
                              </button>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="div__nada">
                        Nenhuma arquivo cadastrado
                      </div>
                    )}

                    {listarchives?.length > listidx && (
                      <div
                        className="div__viewMore"
                        onClick={() => setListidx((v) => v + 3)}
                      >
                        Ver mais
                      </div>
                    )}
                  </div>
                </content>
              </header>
            </Container>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <FielButtons>
            <button
              onClick={handleClose}
              className="btn__retornar"
              color="primary"
              style={{ minWidth: '100px' }}
            >
              Voltar
            </button>
          </FielButtons>
        </DialogActions>
      </Dialog>

      {showconf.status && (
        <Dialogoconfirmacao
          status={showconf.status}
          width={showconf.width}
          delete={showconf.delete}
          description={showconf.description}
          fechar={() =>
            setShowconf((s) => ({ ...s, dados: '', status: false, temp: '' }))
          }
          confirmar={() => {
            if (!showconf.dados) return;

            if (showconf.type === 'SET_PAYMENT_ID' && showconf.receiptId) {
              SET_PAYMENT_ID(
                showconf.receiptId,
                () => {
                  handlePaymentUpdatedLocal(showconf.receiptId, true);
                  props?.onProjectPaymentUpdated?.(
                    dados.id,
                    showconf.receiptId,
                    true
                  );
                  setShowconf({
                    ...showconf,
                    status: false,
                    dados: '',
                    temp: '',
                    type: '',
                    receiptId: undefined,
                  });
                },
                setShowbackdrop
              );
              return;
            }

            if (
              showconf.type === 'SET_CANCEL_PAYMENT_ID' &&
              showconf.receiptId
            ) {
              SET_CANCEL_PAYMENT_ID(
                showconf.receiptId,
                () => {
                  handlePaymentUpdatedLocal(showconf.receiptId, false);
                  props?.onProjectPaymentUpdated?.(
                    dados.id,
                    showconf.receiptId,
                    false
                  );
                  setShowconf({
                    ...showconf,
                    status: false,
                    dados: '',
                    temp: '',
                    type: '',
                    receiptId: undefined,
                  });
                },
                setShowbackdrop
              );
              return;
            }

            if (showconf.pendencia) {
              !showconf.delete ? confirmarPendencia() : deletePendencia();
            } else if (showconf.arquivoVinculado) {
              !showconf.delete ? confirmarArquivo() : deleteArquivoVinculado();
            } else if (showconf.removeDocument) {
              removerArquivo();
            } else if (showconf.removeInverter) {
              deleteInverters();
            }
          }}
        />
      )}

      {showcoord && (
        <Dialogoencontrarlocalizacao
          fechar={() => setShowcoord(false)}
          dados={dados}
          confirmar={(a) =>
            setDados((s) => ({ ...s, longitude: a.lng, latitude: a.lat }))
          }
        />
      )}

      {showPDF.open && (
        <Modalpdf
          fechar={() => setShowPDF({ open: false, file_pdf: '' })}
          fileUrl={showPDF.file_pdf}
        />
      )}

      {showDocumentData.open && (
        <DialogDocumentData
          fechar={() => setShowDocumentData({ open: false, data: {} })}
          data={showDocumentData.data}
        />
      )}

      {viewPixCode.status && (
        <DialogoPixCode
          pixCode={viewPixCode.pixCode}
          handleSetViewPixCode={setViewPixCode}
          onPixUpdated={handlePixUpdated}
          id={viewPixCode.id}
          status={viewPixCode.status}
          drop={setShowbackdrop}
          fechar={() => setViewPixCode({ status: false, id: '', pixCode: '' })}
        />
      )}

      {showbackdrop && <SimpleBackdrop />}
    </div>
  );
}
